export default __webpack_public_path__ + "static/media/gallery-wip-neck_06.5598a64d.jpg";